import React from 'react';
import { toast } from 'react-toastify';

import { ToastMessageBody } from './ToastMessageBody';
import {
  ToastErrorIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
} from './ToastPaletteIcons';
import { DEFAULT_TOAST_AUTO_CLOSE_MS } from './toast-config';

export const successToastMessage = (
  message: React.ReactNode,
  options?: { autoClose?: number | false },
) => {
  return toast.success(
    <ToastMessageBody message={message} titleKey="common.toast.successTitle" />,
    {
      icon: <ToastSuccessIcon />,
      closeButton: true,
      autoClose: options?.autoClose ?? DEFAULT_TOAST_AUTO_CLOSE_MS,
    },
  );
};

const isLocalOrDev =
  process.env.REACT_APP_ENVIRONMENT === 'local' ||
  process.env.REACT_APP_ENVIRONMENT === 'dev';

export const errorToastMessage = (message) => {
  if (isLocalOrDev) {
    console.warn('[errorToast]', message, '\nCall stack:', new Error().stack);
  }
  return toast.error(
    <ToastMessageBody message={message} titleKey="common.toast.errorTitle" />,
    {
      icon: <ToastErrorIcon />,
      closeOnClick: true,
      autoClose: DEFAULT_TOAST_AUTO_CLOSE_MS,
    },
  );
};

export const warningToastMessage = (message) => {
  return toast.warning(
    <ToastMessageBody message={message} titleKey="common.toast.warningTitle" />,
    {
      icon: <ToastWarningIcon />,
      closeButton: false,
      autoClose: DEFAULT_TOAST_AUTO_CLOSE_MS,
    },
  );
};
